import Entities from 'STORE';

export const handleCalendarUnauthorized = (): boolean => {
  // TODO: добавить сообщение если у пользователя слетела авторизация во время пользования календарем
  Entities.calendar.resetCalendarAccounts();
  return true;
};
